import { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";

const SECTIONS = [
  { id: "hero",    label: "HERO" },
  { id: "about",   label: "ABOUT" },
  { id: "fields",  label: "FIELDS" },
  { id: "concept", label: "CONCEPT" },
  { id: "tech",    label: "TECH" },
  { id: "links",   label: "LINKS" },
  { id: "contact", label: "CONTACT" },
];

export function SectionTransitionLabel() {
  const [current, setCurrent] = useState("");
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    SECTIONS.forEach(({ id, label }) => {
      const el = id === "hero"
        ? document.querySelector("section")
        : document.getElementById(id);
      if (!el) return;

      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setCurrent(label);
            setVisible(true);
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setVisible(false), 1800);
          }
        },
        { threshold: 0.5 }
      );
      obs.observe(el);
      observers.push(obs);
    });

    return () => {
      observers.forEach((o) => o.disconnect());
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key={current}
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 40 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="fixed right-6 bottom-12 z-50 pointer-events-none"
        >
          <span
            className="text-3xl md:text-7xl tracking-[0.35em] uppercase font-light"
            style={{
              color: "oklch(0.88 0.18 195 / 0.80)",
              textShadow: "0 0 30px oklch(0.75 0.22 195 / 0.55), 0 0 70px oklch(0.70 0.20 195 / 0.28)",
              fontFamily: "'Rajdhani', sans-serif",
            }}
          >
            {current}
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
